import { render } from "./PrivatePage.vue?vue&type=template&id=dc81b0b0&scoped=true"
import script from "./PrivatePage.vue?vue&type=script&lang=js"
export * from "./PrivatePage.vue?vue&type=script&lang=js"

import "./PrivatePage.vue?vue&type=style&index=0&id=dc81b0b0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dc81b0b0"]])

export default __exports__